var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.576 3.342c.364.318.4.87.082 1.234l-7 8a.875.875 0 0 1-1.322-.007l-3-3.5a.875.875 0 1 1 1.328-1.138l2.343 2.733 6.335-7.24a.875.875 0 0 1 1.234-.082Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export default ForwardRef;